import axios from "axios";

// export const API_BASE_URL = "https://apistaging.motabilityschemelive.co.uk"; // staging
// 
export const API_BASE_URL = "https://api.motabilityschemelive.co.uk"; // production

const basicAuthUser = process.env.REACT_APP_BASIC_AUTH_USERNAME;
const basicAuthPass = process.env.REACT_APP_BASIC_AUTH_PASSWORD;

if (basicAuthUser && basicAuthPass) {
  axios.interceptors.request.use((config) => {
    if (config.url?.startsWith(API_BASE_URL)) {
      config.headers.Authorization =
        "Basic " + btoa(`${basicAuthUser}:${basicAuthPass}`);
    }
    return config;
  });
}
